import type { ReactNode } from "react";
import { useAuth } from "@/lib/auth-context";
import { podeFazer, type Capacidade } from "@shared/permissoes";

export type { Capacidade };
export { podeFazer };

/**
 * "Este usuário pode?" — no client, só para ESCONDER o que a API vai recusar.
 *
 * A fonte é a mesma matriz do servidor (shared/permissoes.ts); o gate de verdade
 * é `requireCap` na rota. Esconder o botão evita oferecer uma ação que
 * responderia 403 — nunca substitui o 403.
 *
 * Em modo SUPORTE (P2, "Entrar como") a sessão vem com `role: 'LEITURA'` e
 * `user.suporte`: tudo que não é leitura é falso, sem caso especial aqui — a
 * matriz já responde isso para LEITURA.
 */
export function usePode(cap: Capacidade): boolean {
  const { user } = useAuth();
  const papel = (user as { suporte?: unknown } | null)?.suporte ? "LEITURA" : user?.role;
  return podeFazer(papel, cap);
}

/** Renderiza os filhos só quando o usuário tem a capacidade. */
export function Pode({ cap, children, senao = null }: { cap: Capacidade; children: ReactNode; senao?: ReactNode }) {
  const pode = usePode(cap);
  return <>{pode ? children : senao}</>;
}
